export default "__VITE_ASSET__DCtHSRhW__"